
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5T7BQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $db56f67ff489629b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $db56f67ff489629b$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Alle websites',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Luk',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(ikke tilg\xe6ngelig i \xf8jeblikket)",
    'navigation.global-shortcuts.sites': '{productName}-websites'
};

});


//# sourceMappingURL=da.51397817.js.map
